import { TActions } from '../../../AppModulesWrapper';

import { ILayoutState } from '../../types/reducers/layout';
import { UPDATE_ADAPTIVE_SETTINGS } from '../../actions/layout';
import { defaultState } from './defaultState';
import { RESET_STATE } from '../../actions/resetState';

export const layout = (state: ILayoutState = defaultState, action: TActions): ILayoutState => {
  switch (action.type) {
    case UPDATE_ADAPTIVE_SETTINGS: {
      return {
        ...state,
        adaptiveSettings: action.payload,
      };
    }

    case RESET_STATE:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
};
